export default function createImage(src: string): Promise<HTMLImageElement> {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    const onLoad = () => {
      // eslint-disable-next-line no-use-before-define
      image.removeEventListener('error', onError)
      resolve(image)
    }
    const onError = () => {
      image.removeEventListener('load', onLoad)
      reject()
    }

    image.addEventListener('load', onLoad, { once: true })
    image.addEventListener('error', onError, { once: true })
    image.src = src
  })
}
